export const lobDashboardSections = {
  policyAndClaims: {
    title: "Policy & Claims",
    cards: [
      {
        id: "total-policy-count",
        title: "Total Policy Count",
        dataPath: "atpOperations.registrationsAndPolicies.totalPolicyCount",
        icon: "claimsCard",
        color: "primary",
        navigateTo: "/bookings",
      },
      {
        id: "total-claims",
        title: "Total Claims",
        dataPath: "atpOperations.claims.totalClaims",
        icon: "claimsCard",
        color: "info",
        navigateTo: "/claims",
      },
      {
        id: "active-policy",
        title: "Active Policy",
        dataPath: "atpOperations.registrationsAndPolicies.activePolicy",
        icon: "claimsCard",
        color: "success",
        navigateTo: "/bookings?status=active",
      },
      {
        id: "active-claims",
        title: "Active Claims",
        dataPath: "atpOperations.claims.activeClaims",
        icon: "claimsCard",
        color: "warning",
        navigateTo: "/claims?status=active",
      },
    ],
  },

  financialOverview: {
    title: "Financial Overview",
    cards: [
      {
        id: "cd-balance-claims",
        title: "C/D Balance Claims",
        dataPath: "atpOperations.financialOverview.cdBalance",
        icon: "totalAmountIcon",
        color: "primary",
        navigateTo: "/cd-balance-claims",
      },
      {
        id: "cd-balance-premium",
        title: "C/D Balance Premium",
        dataPath: "atpOperations.financialOverview.cdBalancePremium",
        icon: "totalAmountIcon",
        color: "primary",
        navigateTo: "/cd-balance-premium",
      },
      {
        id: "totalRedeemAmount",
        title: "total Redeem Amount",
        dataPath: "atpOperations.financialOverview.totalRedeemAmount",
        icon: "redeemAmount",
        color: "success",
        navigateTo: "/vouchers",
      },
    ],
  },
};
